/*
  RIZN – Красивата Жена: доработки по темата (10.2026)
*/
(() => {
  /* 02 · Мобилно търсене зад лупа */
  const header = document.querySelector('header.header');
  const toggle = header && header.querySelector('.rz-search-toggle');

  if (header && toggle) {
    const getInput = () => header.querySelector('.header__search input[type="search"]');
    const isOpen = () => header.classList.contains('rz-search-open');

    const setOpen = (open) => {
      header.classList.toggle('rz-search-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      const input = getInput();
      if (open) {
        // В същия клик, за да се отвори клавиатурата на iOS
        input && input.focus();
      } else {
        input && input.blur();
        const predictive = header.querySelector('predictive-search');
        predictive && typeof predictive.toggleSearchState === 'function' && predictive.toggleSearchState(false);
      }
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(!isOpen());
    });

    const closeButton = header.querySelector('.header__search-close');
    closeButton && closeButton.addEventListener('click', () => setOpen(false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) setOpen(false);
    });

    // Клик извън хедъра затваря търсенето
    document.addEventListener('click', (event) => {
      if (isOpen() && !header.contains(event.target)) setOpen(false);
    });

    document.addEventListener('menu-drawer:open', () => isOpen() && setOpen(false));

    // При преминаване към десктоп ширина
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (event) => {
      if (event.matches && isOpen()) setOpen(false);
    });
  }

  /*
    04 · Табовете на продукта (Описание / Съставки / Как се използва) да не „подскачат“.
    При отваряне на таб предишният се затваря и съдържанието над натиснатото заглавие изчезва,
    затова страницата „скача“. Докато трае анимацията, връщаме страницата така,
    че натиснатото заглавие да остане на същото място на екрана.
  */
  const KEEP_MS = 700;

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('collapsible-tabs details[is="accordion-group"] > summary');
      if (!summary) return;

      const details = summary.parentElement;
      if (details.hasAttribute('open')) return; // затваряне – нищо не се мести над заглавието

      const startTop = summary.getBoundingClientRect().top;
      const endTime = performance.now() + KEEP_MS;
      let cancelled = false;

      const cancel = () => {
        cancelled = true;
      };
      window.addEventListener('wheel', cancel, { once: true, passive: true });
      window.addEventListener('touchmove', cancel, { once: true, passive: true });

      const keepInPlace = () => {
        if (cancelled) return;
        const delta = summary.getBoundingClientRect().top - startTop;
        if (Math.abs(delta) > 0.5) {
          window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
        }
        if (performance.now() < endTime) {
          requestAnimationFrame(keepInPlace);
        } else {
          window.removeEventListener('wheel', cancel);
          window.removeEventListener('touchmove', cancel);
        }
      };

      requestAnimationFrame(keepInPlace);
    },
    true
  );
})();
